export default "__VITE_ASSET__BFQjtQ0b__"